module.exports = __webpack_public_path__ + "static/media/tablets.482a70a7.svg";